import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {UserService} from "../../../providers/service/user.service";
import {Router} from "@angular/router";
import {AlertService} from "../../../providers/service/alert.service";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {GlobalVariablesService, KeyStringValue} from "../../../providers/service/global-variables.service";
import {map, startWith, switchMap} from "rxjs/operators";
import {ParseClass} from "../../../providers/service/parse-api.service";

// import {MyErrorStateMatcher} from "../../../providers/matchers/error-state-matcher";


@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false
})
export class SignupComponent implements OnInit {

    public userForm: UntypedFormGroup;
    public loading = false;
    // public matcher = new MyErrorStateMatcher();
    public hide = true;
    public hide2 = true;
    errorsForm$: Observable<KeyStringValue<any> | undefined | null>
    errorsTwoPassIsEquals$: Observable<boolean>

    constructor(
        private userService: UserService,
        private router: Router,
        private alertService: AlertService,
        private translate: TranslateService,
        private globalVariablesService: GlobalVariablesService
    ) {
        this.userForm = userService.getFormSignup();
        this.errorsForm$ = this.userForm.valueChanges.pipe(
            startWith(),
            map(error => this.userForm.errors)
        )
        this.errorsTwoPassIsEquals$ = this.errorsForm$.pipe(
            map(error => {
                return error != null && error.isEquals == true;
            })
        )
    }

    get logo() {
        return this.globalVariablesService.defaultLogoPc
    }

    save() {
        if (this.userForm.invalid) {
            this.alertService.error(this.translate.instant('compile'));
        } else {
            this.loading = true;
            const getValueForm = (key: string) => {
                if (this.userForm.get(key)) {
                    return this.userForm.get(key)?.value
                } else {
                    return undefined
                }
            }
            const name = getValueForm('name')
            const surname = getValueForm('surname')
            const new_password = getValueForm('new_password')
            this.userService.signup$(name, surname, new_password)
                .pipe(
                    switchMap(() => {
                        return this.userService.web_loginUser({
                            username: this.userService.emailUser!,
                            password: new_password,
                        })
                    }),
                    switchMap(() => {
                        return this.userService.checkIfUserIsActive$()
                    })
                )
                .subscribe(value => {
                    this.loading = false;
                    if (value) {
                        this.userService.checkIfUserIsActive = true;
                        this.router.navigate(['/project']);
                        this.alertService.success(this.translate.instant('welcome', {name: ParseClass.User.current()!.get('name')}));
                        this.userForm.reset();
                    } else {
                        this.alertService.error('failed');
                    }
                }, error => {
                    this.alertService.error(error);
                    this.loading = false;

                });
        }
    }

    ngOnInit(): void {
    }

}
